import React, { memo } from 'react'

import { withLayout } from '@galo-monitor/web-containers/layouts'
import { useRoutes } from '@galo-monitor/web-containers/routes/guest'

import RouterSwitch from '../RouterSwitch'

const GuestScreenRouter = (props) => {
  const { routes } = useRoutes()
  return <RouterSwitch routes={ routes } { ...props } />
}

export default memo(withLayout('guest')(GuestScreenRouter))
